import { render } from "./CollectionResurrectPreviewCard.vue?vue&type=template&id=3ee088c9"
import script from "./CollectionResurrectPreviewCard.vue?vue&type=script&lang=js"
export * from "./CollectionResurrectPreviewCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__